import fetch from './lib/fetch'

export async function getOnetimes(rechargeId: string) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onetimes`,
  )
}

export async function cancelOnetime(rechargeId: string, onetimeId: number) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onetime/${onetimeId}/cancel`,
    {
      method: 'POST',
    },
  )
}

export async function delayOnetime(
  rechargeId: string,
  onetimeId: number,
  until: string,
) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onetime/${onetimeId}/delay`,
    {
      method: 'PUT',
      body: JSON.stringify({
        until,
      }),
      headers: {
        'content-type': 'application/json',
      },
    },
  )
}

export async function updateOnetime(
  rechargeId: string,
  onetimeId: number,
  update: {
    quantity: number
    newVariantId?: string
  },
) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onetime/${onetimeId}`,
    {
      method: 'PUT',
      body: JSON.stringify({
        quantity: update.quantity,
        ...(update.newVariantId ? { variant_id: update.newVariantId } : {}),
      }),
      headers: {
        'content-type': 'application/json',
      },
    },
  )
}

export async function createOnetime(
  rechargeId: string,
  addressId: number,
  productId: string,
  variantId: string,
  nextOrderDate: string,
  quantity: number,
) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onetime`,
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        address_id: addressId,
        product_id: productId,
        variant_id: variantId,
        scheduled_at: nextOrderDate,
        quantity,
      }),
    },
  )
}

export async function createFreeGiftOnetime(
  rechargeId: string,
  addressId: number,
  sourceProductId: string,
  variantId: string,
  nextOrderDate: string,
) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onetime/free-gift`,
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        address_id: addressId,
        product_id: sourceProductId,
        variant_id: variantId,
        scheduled_at: nextOrderDate,
      }),
    },
  )
}
